import ahuComparisonGeneral03 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-comparison-general-03.webp';
import ahuDetailStage02 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-detail-stage-02.webp';
import ahuPreview01 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-preview-01.webp';
import ahuPreview04 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-preview-04.webp';
import ahuPreview05 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-preview-05.webp';
import ahuValueAfter07 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-value-after-07.webp';
import ahuValueBefore06 from '@/assets/images/energy/ahu-filter/custom-gallery/ahu-filter-value-before-06.webp';
import co2MultiSystemImage from '@/assets/images/energy/co2/co2_multi_system.webp';
import co2ComparisonGeneral03 from '@/assets/images/energy/co2/custom-gallery/co2-comparison-general-03.webp';
import co2ComparisonPremium04 from '@/assets/images/energy/co2/custom-gallery/co2-comparison-premium-04.webp';
import co2DetailStage02 from '@/assets/images/energy/co2/custom-gallery/co2-detail-stage-02.webp';
import co2Preview01 from '@/assets/images/energy/co2/custom-gallery/co2-preview-01.webp';
import co2TimelineStage05 from '@/assets/images/energy/co2/custom-gallery/co2-timeline-stage-05.webp';
import co2ValueAfter07 from '@/assets/images/energy/co2/custom-gallery/co2-value-after-07.webp';
import co2ValueBefore06 from '@/assets/images/energy/co2/custom-gallery/co2-value-before-06.webp';
import guntnerComparisonGeneral03 from '@/assets/images/energy/guntner/custom-gallery/guntner-comparison-general-03.webp';
import guntnerComparisonPremium04 from '@/assets/images/energy/guntner/custom-gallery/guntner-comparison-premium-04.webp';
import guntnerDetailStage02 from '@/assets/images/energy/guntner/custom-gallery/guntner-detail-stage-02.webp';
import guntnerPreview01 from '@/assets/images/energy/guntner/custom-gallery/guntner-preview-01.webp';
import guntnerPreview08 from '@/assets/images/energy/guntner/custom-gallery/guntner-preview-08.webp';
import guntnerPreview09 from '@/assets/images/energy/guntner/custom-gallery/guntner-preview-09.webp';
import guntnerTimelineStage05 from '@/assets/images/energy/guntner/custom-gallery/guntner-timeline-stage-05.webp';
import guntnerValueAfter07 from '@/assets/images/energy/guntner/custom-gallery/guntner-value-after-07.webp';
import guntnerValueBefore06 from '@/assets/images/energy/guntner/custom-gallery/guntner-value-before-06.webp';
import haierCarrierComparisonGeneral03 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-comparison-general-03.webp';
import haierCarrierComparisonPremium04 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-comparison-premium-04.webp';
import haierCarrierDetailStage02 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-detail-stage-02.webp';
import haierCarrierPreview01 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-preview-01.webp';
import haierCarrierPreview08 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-preview-08.webp';
import haierCarrierPreview09 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-preview-09.webp';
import haierCarrierTimelineStage05 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-timeline-stage-05.webp';
import haierCarrierValueAfter07 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-value-after-07.webp';
import haierCarrierValueBefore06 from '@/assets/images/energy/haier-carrier/custom-gallery/haier-carrier-value-before-06.webp';
import motorComparisonGeneral03 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-comparison-general-03.webp';
import motorDetailStage02 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-detail-stage-02.webp';
import motorPreview01 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-preview-01.webp';
import motorPreview04 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-preview-04.webp';
import motorPreview05 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-preview-05.webp';
import motorValueAfter07 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-value-after-07.webp';
import motorValueBefore06 from '@/assets/images/energy/motor-direct-control/custom-gallery/motor-direct-value-before-06.webp';
import openShowcaseDoorComparisonGeneral03 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-comparison-general-03.webp';
import openShowcaseDoorComparisonPremium04 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-comparison-premium-04.webp';
import openShowcaseDoorDetailStage02 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-detail-stage-02.webp';
import openShowcaseDoorPreview01 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-preview-01.webp';
import openShowcaseDoorTimelineStage05 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-timeline-stage-05.webp';
import openShowcaseDoorValueAfter07 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-value-after-07.webp';
import openShowcaseDoorValueBefore06 from '@/assets/images/energy/open-showcase-door/custom-gallery/open-showcase-door-value-before-06.webp';

export const energyImages = {
  ahuFilter: {
    customGallery: {
      comparisonGeneral03: ahuComparisonGeneral03,
      detailStage02: ahuDetailStage02,
      preview01: ahuPreview01,
      preview04: ahuPreview04,
      preview05: ahuPreview05,
      valueAfter07: ahuValueAfter07,
      valueBefore06: ahuValueBefore06,
    },
  },
  co2: {
    customGallery: {
      comparisonGeneral03: co2ComparisonGeneral03,
      comparisonPremium04: co2ComparisonPremium04,
      detailStage02: co2DetailStage02,
      preview01: co2Preview01,
      timelineStage05: co2TimelineStage05,
      valueAfter07: co2ValueAfter07,
      valueBefore06: co2ValueBefore06,
    },
    multiSystem: co2MultiSystemImage,
  },
  motorDirectControl: {
    customGallery: {
      comparisonGeneral03: motorComparisonGeneral03,
      detailStage02: motorDetailStage02,
      preview01: motorPreview01,
      preview04: motorPreview04,
      preview05: motorPreview05,
      valueAfter07: motorValueAfter07,
      valueBefore06: motorValueBefore06,
    },
  },
  openShowcaseDoor: {
    customGallery: {
      comparisonGeneral03: openShowcaseDoorComparisonGeneral03,
      comparisonPremium04: openShowcaseDoorComparisonPremium04,
      detailStage02: openShowcaseDoorDetailStage02,
      preview01: openShowcaseDoorPreview01,
      timelineStage05: openShowcaseDoorTimelineStage05,
      valueAfter07: openShowcaseDoorValueAfter07,
      valueBefore06: openShowcaseDoorValueBefore06,
    },
  },
  guntner: {
    customGallery: {
      comparisonGeneral03: guntnerComparisonGeneral03,
      comparisonPremium04: guntnerComparisonPremium04,
      detailStage02: guntnerDetailStage02,
      preview01: guntnerPreview01,
      preview08: guntnerPreview08,
      preview09: guntnerPreview09,
      timelineStage05: guntnerTimelineStage05,
      valueAfter07: guntnerValueAfter07,
      valueBefore06: guntnerValueBefore06,
    },
  },
  haierCarrier: {
    customGallery: {
      comparisonGeneral03: haierCarrierComparisonGeneral03,
      comparisonPremium04: haierCarrierComparisonPremium04,
      detailStage02: haierCarrierDetailStage02,
      preview01: haierCarrierPreview01,
      preview08: haierCarrierPreview08,
      preview09: haierCarrierPreview09,
      timelineStage05: haierCarrierTimelineStage05,
      valueAfter07: haierCarrierValueAfter07,
      valueBefore06: haierCarrierValueBefore06,
    },
  },
} as const;
